import React from "react";
import { Handshake, MapPin, Clock, UserCheck } from "lucide-react";
import Reveal from "./Reveal";

const STATS = [
  {
    icon: Handshake,
    title: "100% z Polecenia",
    desc: "Nowi klienci trafiają do nas dzięki rekomendacji kogoś, komu już wcześniej pomogliśmy.",
  },
  {
    icon: MapPin,
    title: "Cały region",
    desc: "Bieszczady i całe Podkarpacie. Pracujemy tam, gdzie naprawdę mieszkają nasi klienci.",
  },
  {
    icon: Clock,
    title: "Sprawna komunikacja",
    desc: "Nie zostawiamy klientów w niepewności. Odpowiadamy na czas.",
  },
  {
    icon: UserCheck,
    title: "Indywidualne podejście",
    desc: "Każde ubezpieczenie dobieramy do konkretnej sytuacji życiowej, nie do tabelki.",
  },
];

export const About = () => {
  return (
    <section
      id="o-mnie"
      data-testid="about-section"
      className="py-20 md:py-28 bg-cream"
    >
      <div className="container-narrow">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <Reveal>
              <div className="text-mustard-dark font-heading font-bold uppercase text-sm tracking-wider mb-3">
                O mnie
              </div>
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-forest leading-tight">
                Pośrednictwo ubezpieczeniowe<br />
                zbudowane na zadowoleniu klienta.
              </h2>
              <div className="mt-6 space-y-4 text-ink/90 text-base md:text-lg leading-relaxed">
                <p>
                  Przez ponad 13 lat rozmawialiśmy z tysiącami klientów z całego
                  regionu, a polisy dobieraliśmy indywidualnie do każdego klienta
                  tak, aby pasowały one do Waszych wymagań i potrzeb.
                </p>
                <p>
                  Nasi klienci pochodzą z polecenia, co stanowi dowód, że filarem
                  tej firmy jest zadowolenie potrzeb klienta, zgodnie z jego
                  oczekiwaniami.
                </p>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <div className="grid sm:grid-cols-2 gap-4 md:gap-5">
              {STATS.map((stat, i) => {
                const Icon = stat.icon;
                return (
                  <Reveal key={stat.title} delay={i * 80}>
                    <div
                      data-testid={`about-stat-${i}`}
                      className="bg-white rounded-xl p-6 md:p-7 border border-bordersoft hover:border-forest/20 transition-colors h-full"
                    >
                      <div className="w-11 h-11 rounded-lg bg-forest/8 flex items-center justify-center mb-4">
                        <Icon size={22} className="text-forest" strokeWidth={2} />
                      </div>
                      <div className="font-heading font-semibold text-forest text-lg mb-2">
                        {stat.title}
                      </div>
                      <p className="text-ink-muted text-base leading-relaxed">
                        {stat.desc}
                      </p>
                    </div>
                  </Reveal>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
